import { ReactElement } from 'react';
import { Control, FieldValues, Path, useController } from 'react-hook-form';

import { Slider } from '../Slider';

interface SliderControllerProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}

export function SliderController<T extends FieldValues>({
  name,
  control,
  min = 0,
  max = 100,
  step = 10,
  disabled,
}: SliderControllerProps<T>): ReactElement {
  const {
    field: { value, onChange },
  } = useController({ name, control });

  return (
    <Slider
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
    />
  );
}
